// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"style-module_disabled__xiQloHYw8cYQg78DqfEm"};